import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";
import CategorieSection from "./categorieSection";
import { useParams } from "react-router-dom";

export const IndividualBlog = () => {
  const { blogid } = useParams();
  const [blogs, setBlogs] = useState([]);
  const [BreadcrumList, setBreadcrumList] = useState([]);

  const fetchBreadcrumImageData = async () => {
    try {
      const response = await corefetch(
        "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=BLOG"
      );
      if (response && response.length > 0) {
        console.log("fxftyxfyt:", response);
        setBreadcrumList(response);
      } else {
        setBreadcrumList([]);
        console.log("No Breadcrum found");
      }
    } catch (error) {
      console.error("Error fetching Breadcrum List:", error);
      setBreadcrumList([]);
    }
  };

  useEffect(() => {
    fetchBreadcrumImageData();
  }, []);

  const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};
  const fetchBlogData = async () => {
    try {
      const response = await corefetch(`Blog/GetBlogDetailByID?Id=${blogid}`);
      if (response && response.length > 0) {
        setBlogs(response);
      } else {
        setBlogs([]);
        console.error("No blog data found");
      }
    } catch (error) {
      setBlogs([]);
      console.error("Failed to fetch blog data", error);
    }
  };
  useEffect(() => {
    fetchBlogData();
  }, []);

  if (!blogs || blogs.length == 0) {
    return null;
  }
  return (
    <>
      <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h2>{blogs[0].displayedInName}</h2>
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/home">Home</a>
                  </li>
                  <li>
                    <a href="/blogs">Blog</a>
                  </li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </section>
      {blogs.map((blog, index) => {
        const eventDate = new Date(blog.eventDate);
        const day = eventDate.getDate();
        const month = eventDate.toLocaleString("default", {
          month: "short",
        });
        const year = eventDate.getFullYear();
        return (
          <section
            className="wpo-blog-single-section wpo-blog-single-left-sidebar-section section-padding"
            style={{ marginTop: "20px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col col-lg-8 col-12 order-lg-2">
                  <div className="wpo-blog-content">
                    <div className="post format-standard-image">
                      <div className="entry-media">
                        <img
                          src={`${ImageURL}${blog.imagePath}`}
                          alt
                          style={{ height: "auto", objectFit: "cover" }}
                        />
                      </div>
                      <div className="entry-meta">
                        <ul>
                          <li>
                            <i className="fi flaticon-calendar" />{" "}
                            {`${month} ${day} ${year}`}
                          </li>
                        </ul>
                      </div>
                      <h2>{blog.title}</h2>
                      <div
                        className="blogFront"
                        dangerouslySetInnerHTML={{ __html: blog.description }}
                      />
                    </div>
                  </div>
                </div>
                <CategorieSection />
              </div>
            </div>{" "}
            {/* end container */}
          </section>
        );
      })}
    </>
  );
};
